import React, { ErrorInfo } from 'react';
import type { PropsWithChildren } from 'react';
import FenixProvider from '@pedidosya/web-fenix/contexts/FenixContext';
import FeedbackPage from '@pedidosya/web-fenix/system/FeedbackPage';
import FooterButton from '@pedidosya/web-fenix/system/FooterButton';
import { Constants } from '@app/orders/infra/config/Constants';
import { getWindow } from '@app/shared/utils/window';
import { isWebView } from '@app/shared/utils/webview';
import { sentryHub } from '@app/shared/utils/sentry';
import { getFenixIllustration } from '@pedidosya/web-fenix/utils/image';

type MyState = {
  hasError: boolean;
  error: any;
};

type Props = {
  fenixVersion: string;
} & PropsWithChildren;

export class GlobalError extends React.Component<Props, MyState> {
  constructor(props: Props) {
    super(props);
    this.state = { error: null, hasError: false };
  }

  static getDerivedStateFromError(error: unknown) {
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: ErrorInfo) {
    this.setState({ error, hasError: true });
    if (error?.__sentry_captured__) {
      // Allow the hub to re-catch the error if the main sentry instance already caught it
      delete error.__sentry_captured__;
    }
    if (sentryHub) {
      sentryHub.withScope((scope) => {
        scope.setExtra('componentStack', errorInfo.componentStack);
        sentryHub.captureException(error);
      });
    }
  }

  render() {
    const { hasError } = this.state;
    if (hasError) {
      const wn = getWindow();
      const webview = isWebView();

      return (
        <FenixProvider config={{ fenixVersion: this?.props?.fenixVersion || '2.2' }}>
          <FeedbackPage
            title="No pudimos cargar el listado de pedidos"
            description="Entregar una experiencia increíble, siempre."
            imageSrc={getFenixIllustration(Constants.GENERAL_ERROR_ILUSTRATION)}
          >
            <FeedbackPage.TopBar
              left={webview ? 'empty' : 'icon'}
              right="empty"
              middle="empty"
              onGoBack={() => wn.history.back()}
            />
            <FeedbackPage.FooterButton>
              <FooterButton.Button
                fullWidth
                hierarchy="primary"
                label="Volver a intentar"
                onClick={() => wn.location.reload()}
                size="large"
              />
            </FeedbackPage.FooterButton>
          </FeedbackPage>
        </FenixProvider>
      );
    }

    return this.props.children;
  }
}
